export const FETCH_CATALOG_PRODUCTS_LIST_SUCCESS = 'CATALOG/FETCH_CATALOG_PRODUCTS_LIST_SUCCESS';
export const FETCH_CATALOG_PRODUCTS_LIST_ERROR = 'CATALOG/FETCH_CATALOG_PRODUCTS_LIST_ERROR';
export const CLEAR_FETCH_CATALOG_PRODUCTS_LIST = 'CATALOG/CLEAR_FETCH_CATALOG_PRODUCTS_LIST';

export const APPLY_PRODUCT_DRAG_SUCCESS = 'CATALOG/APPLY_PRODUCT_DRAG_SUCCESS';
export const APPLY_PRODUCT_DRAG_ERROR = 'CATALOG/APPLY_PRODUCT_DRAG_ERROR';
export const CLEAR_PRODUCT_DRAG = 'CATALOG/CLEAR_PRODUCT_DRAG';

export const ADD_PRODUCT_LINK_SUCCESS = 'CATALOG/ADD_PRODUCT_LINK_SUCCESS';
export const ADD_PRODUCT_LINK_ERROR = 'CATALOG/ADD_PRODUCT_LINK_ERROR';
export const CLEAR_ADD_PRODUCT_LINK = 'CATALOG/CLEAR_ADD_PRODUCT_LINK';

export const DELETE_PRODUCT_LINK_SUCCESS = 'CATALOG/DELETE_PRODUCT_LINK_SUCCESS';
export const DELETE_PRODUCT_LINK_ERROR = 'CATALOG/DELETE_PRODUCT_LINK_ERROR';
export const CLEAR_DELETE_PRODUCT_LINK = 'CATALOG/CLEAR_DELETE_PRODUCT_LINK';

export const PATCH_PRODUCT_LINK_SUCCESS = 'CATALOG/PATCH_PRODUCT_LINK_SUCCESS';
export const PATCH_PRODUCT_LINK_ERROR = 'CATALOG/PATCH_PRODUCT_LINK_ERROR';
export const CLEAR_PATCH_PRODUCT_LINK = 'CATALOG/CLEAR_PATCH_PRODUCT_LINK';

export const FETCH_CATALOG_DESCRIPTION_SUCCESS = 'CATALOG/FETCH_CATALOG_DESCRIPTION_SUCCESS';
export const FETCH_CATALOG_DESCRIPTION_ERROR = 'CATALOG/FETCH_CATALOG_DESCRIPTION_ERROR';
export const CLEAR_FETCH_CATALOG_DESCRIPTION = 'CATALOG/CLEAR_FETCH_CATALOG_DESCRIPTION';

export const PATCH_CATALOG_DESCRIPTION_SUCCESS = 'CATALOG/PATCH_CATALOG_DESCRIPTION_SUCCESS';
export const PATCH_CATALOG_DESCRIPTION_ERROR = 'CATALOG/PATCH_CATALOG_DESCRIPTION_ERROR';
export const CLEAR_PATCH_CATALOG_DESCRIPTION = 'CATALOG/CLEAR_PATCH_CATALOG_DESCRIPTION';
